import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { WorkCalendar } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditWorkCalendar from './EditWorkCalendar.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        workCalendar: WorkCalendar;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'WorkCalendarsTableActions',
  props: {
    workCalendar: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.workCalendar }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).WORK_CALENDARS_UPDATE))
        ? (_openBlock(), _createBlock(EditWorkCalendar, {
            key: 0,
            workCalendar: _ctx.workCalendar
          }, null, 8, ["workCalendar"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).WORK_CALENDARS_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: _ctx.route('v2.salary.work-calendars.destroy', _ctx.workCalendar.id),
            "query-key": [_unref(QueryKey).WORK_CALENDARS],
            header: "work-calendars.delete.title",
            description: "work-calendars.delete.content"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})